import { render, staticRenderFns } from "./BDcy.vue?vue&type=template&id=5efc5f3b&scoped=true"
import script from "./BDcy.vue?vue&type=script&lang=js"
export * from "./BDcy.vue?vue&type=script&lang=js"
import style0 from "./BDcy.vue?vue&type=style&index=0&id=5efc5f3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5efc5f3b",
  null
  
)

export default component.exports